import React from 'react';
import InfoPageLayout from './InfoPageLayout';

export default function PrivacyPage() {
  return (
    <InfoPageLayout
      title="Privacy Policy | Lilycove"
      description="Read how Lilycove handles privacy and personal data."
      heading="Privacy"
      body="Lilycove collects only the data required to operate accounts, search features, and analytics needed for product reliability. We do not sell personal information, and we minimize retention where practical. A full policy revision can expand this page as legal copy is finalized."
    />
  );
}
